import { render } from "./TheDeletedAlarmsList.vue?vue&type=template&id=61242f55"
import script from "./TheDeletedAlarmsList.vue?vue&type=script&lang=js"
export * from "./TheDeletedAlarmsList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__